import axios from 'axios';


export default axios.create({
    timeout: 10000,
});



// WEBPACK FOOTER //
// ./src/http/shopifyAJAXAPI.js